/**
 * In-memory Zustand store for attribute-master definition data.
 *
 * This store is the in-process cache layer that sits above IndexedDB.
 * Data here survives re-renders and component unmounts but is lost on
 * a full page reload (IndexedDB serves as the persistent fallback).
 */

import { create } from 'zustand'
import type { AttributeDefinition } from '@/services/attributeService'

interface AttributeState {
  /** category key → array of AttributeDefinition */
  cache: Record<string, AttributeDefinition[]>

  /** Store definitions for a category (replaces existing entry if present). */
  setCache: (category: string, attributes: AttributeDefinition[]) => void

  /** Clear all cached categories from memory (e.g. on New Inspection). */
  clearCache: () => void
}

export const useAttributeStore = create<AttributeState>()((set) => ({
  cache: {},

  setCache: (category, attributes) =>
    set((s) => ({ cache: { ...s.cache, [category]: attributes } })),

  clearCache: () => set({ cache: {} }),
}))
